module.exports = __webpack_public_path__ + "static/media/fonts-8.2ddcd37f.svg";